import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useState } from "react";
import useLang from "Shared/hooks/useLanguage";

interface SensitivityDataItem {
  id: number;
  panelId: number;
  panelName: string;
  panelCode: string;
  testConfigId: number;
  testName: string;
  testCode: string;
  mic: string;
  interpretation: string;
  requsitionOrderId: number;
  tabId: number;
  isManual: boolean;
}

interface SensitivityDataTableProps {
  data: SensitivityDataItem[];
  onMicChange?: (id: number, mic: string) => void;
  onInterpretationChange?: (id: number, interpretation: string) => void;
}

const SensitivityDataTable: React.FC<SensitivityDataTableProps> = ({
  data,
  onMicChange,
  onInterpretationChange,
}) => {
  // const { t } = useLang();
  const [localData, setLocalData] = useState<SensitivityDataItem[]>(data);

  React.useEffect(() => {
    setLocalData(data);
  }, [data]);

  // const handleMicChange = (id: number, value: string) => {
  //   const updated = localData.map((item) =>
  //     item.id === id ? { ...item, mic: value } : item
  //   );
  //   setLocalData(updated);
  //   onMicChange?.(id, value);
  // };

  // const handleInterpretationChange = (id: number, value: string) => {
  //   const updated = localData.map((item) =>
  //     item.id === id ? { ...item, interpretation: value } : item
  //   );
  //   setLocalData(updated);
  //   onInterpretationChange?.(id, value);
  // };

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      <div className="table_bordered overflow-hidden">
        <TableContainer component={Paper} className="shadow-none">
          <Table
            className="table table-bordered table-head-2-bg table-bg table-head-custom table-vertical-center border-0 mb-0"
            aria-label="sensitivity data table"
          >
            <TableHead>
              <TableRow className="h-30px">
                <TableCell className="fw-bold" sx={{ width: "40%" }}>
                  ANTIMICROBIAL
                </TableCell>
                <TableCell className="fw-bold" sx={{ width: "30%" }}>
                  M.I.C
                </TableCell>
                <TableCell className="fw-bold" sx={{ width: "30%" }}>
                  Interpretation
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {localData.map((row) => (
                <TableRow key={row.id} sx={{ "& > *": { padding: "4px 8px" } }}>
                  <TableCell component="th" scope="row" sx={{ padding: "4px 8px" }}>
                    {row.testName}
                  </TableCell>
                  <TableCell component="th" scope="row" sx={{ padding: "4px 8px" }}>
                    {row.mic}
                  </TableCell>
                  <TableCell component="th" scope="row" sx={{ padding: "4px 8px" }}>
                    {row.interpretation}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default SensitivityDataTable;
